import { createReducer } from "redux-create-reducer";

import {
  GET_WATCHLIST_UPDATE_LOGS,
  GET_WATCHLIST_UPDATE_LOGS_COUNT,
  SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE,
  SET_WATCHLIST_UPDATE_LOGS_PAGE,
} from "../types";

const initialState = {
  data: [],
  pageInfo: {
    count: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  filters: {
    isSuccessful: true,
  },
  entries: [],
  isLoading: false,
};

const watchlistUpdateLogsReducer = createReducer(initialState, {
  [SET_WATCHLIST_UPDATE_LOGS_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [GET_WATCHLIST_UPDATE_LOGS_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCHLIST_UPDATE_LOGS_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCHLIST_UPDATE_LOGS_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCHLIST_UPDATE_LOGS_COUNT.FULFILLED]: (state, { payload }) => {
    const hasResults = payload.data > 0;
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: payload.data,
      },
      isLoading: hasResults,
    };
  },
  [GET_WATCHLIST_UPDATE_LOGS.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCHLIST_UPDATE_LOGS.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCHLIST_UPDATE_LOGS.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCHLIST_UPDATE_LOGS.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: payload.data,
    isLoading: false,
  }),
  [SET_WATCHLIST_UPDATE_LOGS_ITEMS_PER_PAGE]: (state, { payload }) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
});

export default watchlistUpdateLogsReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/watchlistUpdateLogsReducer.js